import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import SafeUrlAssembler from 'safe-url-assembler';
import { ApiEndpointService } from '../../../core/services/api-endpoint.service';
import { IMfaCreationResponse } from './models/mfa-creation-response.interface';
import { IMfaValidationResponse } from './models/mfa-validation-response.interface';

@Injectable()
export class ViewAccessCodeService {
    public constructor(private readonly http: HttpClient,
                       private readonly apiEndpointService: ApiEndpointService,
    ) {
    }

    public requestMFA(shipmentId: string): Observable<IMfaCreationResponse> {
        const endpoint = SafeUrlAssembler()
            .template(this.apiEndpointService.getEndpoint('requestMFA'))
            .param('shipmentId', shipmentId)
            .toString();
        return this.http.post<IMfaCreationResponse>(endpoint, {});
    }

    public validateMFA(shipmentId: string, mfa: string): Observable<IMfaValidationResponse> {
        const endpoint = SafeUrlAssembler()
            .template(this.apiEndpointService.getEndpoint('validateMFA'))
            .param('shipmentId', shipmentId)
            .toString();
        return this.http.post<IMfaValidationResponse>(endpoint, { mfa });
    }
}
